// extracted by mini-css-extract-plugin
export default {"bannerImg":"index_bannerImg_0kB05","bottomInfo":"index_bottomInfo_dJDBb","buttonlist":"index_buttonlist_MY1nZ","button":"index_button_7ozvx"};